import { web3 } from "@alephium/web3";
import React, { useEffect, useState } from "react";
import { formatTxId } from "../utils/Formatters";

interface PendingTXProps {
    isOpen: boolean; // Controls visibility of the modal
    onClose: () => void; // Function to close the modal
    txID: string; // Transaction hash to display
}

const PendingTX: React.FC<PendingTXProps> = ({
    isOpen,
    onClose,
    txID,
}) => {
    const [txStatus, setTxStatus] = useState<string>("Pending");

    useEffect(() => {
        if (!isOpen) return; // Only run the effect when the modal is open

        const checkTransactionStatus = async () => {
            try {
                const res = await web3.getCurrentNodeProvider().transactions.getTransactionsStatus({ txId: txID })
                setTxStatus(res.type || "Pending");
            } catch (error) {
                console.error("Error fetching transaction status:", error);
            }
        };

        // Run the function immediately and then every 5 seconds
        checkTransactionStatus();
        const interval = setInterval(checkTransactionStatus, 5000);

        return () => clearInterval(interval); // Cleanup interval when modal closes
    }, [isOpen, txID]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-gray-900 text-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[400px] relative">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-200"
                >
                    ✕
                </button>
                <h2 className="text-lg font-bold mb-4">Transaction Status</h2>
                <p className="text-sm mb-4">
                    Transaction ID: {formatTxId(txID)}
                </p>
                <p className="text-sm mb-4">
                    <strong>Status:</strong> {txStatus}
                </p>
                <a
                    href={`${process.env.REACT_APP_EXPLORER_URL}/transactions/${txID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-red-400 hover:text-red-600 underline break-words"
                >
                    View on Explorer
                </a>
                <div className="mt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 w-full"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PendingTX;
